import {
    GET_AUTO_PAYOUT_SETTINGS,
    GET_PAYOUT_REQUESTS,
} from '../actions/payoutRequests';

const INITIAL_STATE = {
    ordered: [],
    filterByCustomer: null, // filter
    limit: 25,
    loadMoreExhausted: false,
    updated: null,
    permissionError: false,
    autoPayoutSettings: null
};

const payoutRequests = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_PAYOUT_REQUESTS:
            return {
                ...state,
                ...action.dataMap,
                ordered: action.replace ? [...(action.ordered || [])] : [...state.ordered, ...(action.ordered || [])],
                loadMoreExhausted: action.loadMoreExhausted,
                updated: action.updated,
                permissionError: false
            };
        case GET_AUTO_PAYOUT_SETTINGS:
            return {
                ...state,
                autoPayoutSettings: action.autoPayoutSettings
            };
        /*case GET_ISSUED_INVOICES_PERMISSION_ERROR:
            return {
                ...state,
                permissionError: true
            };
        case FILTER_ISSUED_INVOICES_BY_COMPANY:
            return {
                ...state,
                filterByCustomer: action.customer,
                ordered: [],
                loadMoreExhausted: false,
                permissionError: false
            };*/
        default:
            return state;
    }
};

export default payoutRequests;
